import { handleSubState, handleAction } from 'uix/actions';
import { setModsFormValue } from './actions';
import log from 'uix/logging';
export const data = [
    handleSubState('modsforms', [
        handleAction(setModsFormValue, ({ changed, ...modsforms }, { payload })=>{
            let { uid, fpath, value } = payload;
            let next = {
                ...changed[uid] ?? {},
                [fpath]: value
            };
            return {
                ...modsforms,
                changed: {
                    ...changed,
                    [uid]: next
                }
            };
        })
    ], {
        changed: {}
    } // key: form-uid, value: dict of {fpath: value}
    )
];
